export function FontDownloadIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.6415 12.9166H12.3415L13.2915 15.4166H15.0332L10.7748 4.58329H9.22484L4.9665 15.4166H6.70817L7.6415 12.9166ZM9.99984 6.64996L11.7248 11.25H8.27484L9.99984 6.64996ZM16.6665 1.66663H3.33317C2.4165 1.66663 1.6665 2.41663 1.6665 3.33329V16.6666C1.6665 17.5833 2.4165 18.3333 3.33317 18.3333H16.6665C17.5832 18.3333 18.3332 17.5833 18.3332 16.6666V3.33329C18.3332 2.41663 17.5832 1.66663 16.6665 1.66663ZM16.6665 16.6666H3.33317V3.33329H16.6665V16.6666Z"
        fill="currentColor"
      />
    </svg>
  )
}
